export const HERO_CONSTANTS = {
  button: {
    label: "Secure Your Infrastructure Today",
    link: "#contact-us",
  },
  content:
    "Host your infrastructure in highly secure, redundant data centers with 24/7 monitoring, optimal cooling, and seamless scalability.",
  title: "Secure, Reliable, and Scalable Colocation Services",
};
